var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVirgo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 8.3335C7.35507 8.3335 8.41488 8.77248 9.19628 9.55388C9.97768 10.3353 10.4167 11.3951 10.4167 12.5002M10.4167 12.5002V31.2502M10.4167 12.5002C10.4167 11.3951 10.8557 10.3353 11.6371 9.55388C12.4185 8.77248 13.4783 8.3335 14.5833 8.3335C15.6884 8.3335 16.7482 8.77248 17.5296 9.55388C18.311 10.3353 18.75 11.3951 18.75 12.5002M18.75 12.5002V31.2502M18.75 12.5002C18.75 11.3951 19.189 10.3353 19.9704 9.55388C20.7518 8.77248 21.8116 8.3335 22.9167 8.3335C24.0217 8.3335 25.0815 8.77248 25.8629 9.55388C26.6443 10.3353 27.0833 11.3951 27.0833 12.5002V33.3335C27.0833 36.0962 28.6198 38.7457 31.3547 40.6992C34.0896 42.6527 37.7989 43.7502 41.6667 43.7502",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 43.7503C28.8677 43.7503 32.5771 42.6529 35.312 40.6994C38.0469 38.7459 39.5833 36.0963 39.5833 33.3337V29.167C39.5833 27.5094 38.9249 25.9197 37.7528 24.7476C36.5806 23.5755 34.9909 22.917 33.3333 22.917C31.6757 22.917 30.086 23.5755 28.9139 24.7476C27.7418 25.9197 27.0833 27.5094 27.0833 29.167",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirgo);
export default __webpack_public_path__ + "static/media/virgo.30b1d2d8a4d639d1faf057b339ed9b97.svg";
export { ForwardRef as ReactComponent };